import Event from "../../../sdk/src/utils/event";
import {SYSTEM_EVENTS} from "../../../sdk/src/events/events";
import {GNWP_SOURCES} from "../gnwp/gnwp-consts";
import {IOmgHandlerHook} from "../external-links/handlers/omg/omg-handler.hook.interface";

export class SdkEventsTrigger {
    gameOpen(eventData: {gameType: number; isReal: boolean}): void {
        Event.fire(SYSTEM_EVENTS.GAME_OPEN, {
            gametype: eventData.gameType,
            gameType: eventData.gameType,
            isReal: eventData.isReal
        });
    }

    gameClosed(eventData: {gameType: number; isReal: boolean; isGamePlayed: boolean; showNextGameSuggestion: boolean}): void {
        Event.fire(SYSTEM_EVENTS.CLOSE_GAME, {
            gametype: eventData.gameType,
            gameType: eventData.gameType,
            isReal: eventData.isReal,
            isGamePlayed: eventData.isGamePlayed,
            showNextGameSuggestion: eventData.showNextGameSuggestion
        });
    }

    keepAlive(): void {
        Event.fire(SYSTEM_EVENTS.EXTEND_USER_TIME_TO_LIVE);
    }

    liveGameSwitched(): void {
        Event.fire(SYSTEM_EVENTS.LIVE_GAME_SWITCHED);
    }

    hybridGameLoadingIndicatorClosed(): void {
        Event.fire(SYSTEM_EVENTS.LOADING_INDICATOR_EMBEDDED_CLOSED_BY_X);
    }

    updateMarketingParams(marketingParams: any): void {
        Event.fire(SYSTEM_EVENTS.INCOMING_MARKETING_DATA, marketingParams);
    }


    navigateToGameInWebView(url: string): void {
        Event.fire(SYSTEM_EVENTS.WEB_VIEW_NAVIGATE_GAME, url);
    }

    gameSequenceFinishedSuccess(): void {
        Event.fire(SYSTEM_EVENTS.GAME_SEQUENCE_FINISH, true);
    }

    showHybridAlert(message: string): void {
        Event.fire(SYSTEM_EVENTS.HYBRID_ALERT, message);
    }

    locationPopupClosed(): void {
        Event.fire(SYSTEM_EVENTS.LOCATION_POPUP_CLOSED);
    }

    registrationCompleted(params: {UserInfo: string, SourceProductPackage: string}) {
        Event.fire(SYSTEM_EVENTS.REGISTRATION_COMPLETED, params);
    }

    externalLinkClosed(params: {gnwpSource: GNWP_SOURCES}): void {
        Event.fire(SYSTEM_EVENTS.EXTERNAL_LINK_CLOSED, params.gnwpSource)
    }

    omgDisplayed(omgHook: IOmgHandlerHook): void {
        Event.fire(SYSTEM_EVENTS.OMG_DISPLAYED, omgHook)
    }

    closeAllSecondWebViews(): void {
        Event.fire(SYSTEM_EVENTS.SECOND_WEB_VIEW_CLOSE_ALL);
    }

    closeNyxSecondWebView(): void {
        Event.fire(SYSTEM_EVENTS.SECOND_WEB_VIEW_CLOSE_NYX);
    }

    openUrlInSecondWebView(url: string): void {
        Event.fire(SYSTEM_EVENTS.SECOND_WEB_VIEW_NAVIGATE_SPORT, url);
    }

    closeModifyBimetricDialog(): void {
        Event.fire(SYSTEM_EVENTS.TOUCH_ID_STATE_CHANGED);
    }

    onInitScreenShow(): void {
        Event.fire(SYSTEM_EVENTS.TOUCH_ID_INIT_SCREEN_SHOW);
    }

    enableHybridGeoLocation(enabled: boolean): void {
        Event.fire(SYSTEM_EVENTS.GEO_HYBRID_UPDATE_ENABLE, enabled);
    }

    hybridGeoLocation(geoParams: {license: string;
                                    sessionKey: string;
                                    userId: string
                                    phone: string;
                                    reason: string;
                                    identifierType: string }): void {
        Event.fire(SYSTEM_EVENTS.GEO_HYBRID_GET_LOCATION, geoParams);
    }
}